<template>
  <section>
    <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper p-0">
        <router-view></router-view>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {

  },
  watch: {

  },
  created() {
    this.$Progress.start();
    this.$Progress.finish();
  }
}
</script>
